import { CookieConsentComponent } from "../non-editable/misc";

export const Layout = ({ children }: any) => (
  <>
    <main>{children}</main>
    <CookieConsentComponent />
  </>
);
